export type RegionConfig = {
	mainCountryCode: string;
};

export const RegionConfig: Record<string, RegionConfig> = {
	'ua': {
		mainCountryCode: 'ua',
	},
	'pl': {
		mainCountryCode: 'pl',
	},
};

export const getRegionConfig = (region?: string): {
	tKey: (k: string) => string;
} & (RegionConfig | undefined) => {
	if (!region)
	{
		region = process.env.NEXT_PUBLIC_APP_REGION || process.env.APP_REGION || 'ua';
	}

	const rConfig: RegionConfig = (RegionConfig[region] || RegionConfig['ua']);

	return {
		...rConfig,
		tKey: (k) => {
			return `base-common:region.${region}.${k}`;
		}
	}
}